import { render } from "./AppAttendanceTopButtons.vue?vue&type=template&id=35f4bdd2"
import script from "./AppAttendanceTopButtons.vue?vue&type=script&lang=js"
export * from "./AppAttendanceTopButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__